import { ConfidenceLevel } from "@teaming/common-enums";

export default {
	text: "{changedBy} changed the confidence level of KR <a href='#' data-action='key-result'>{name}</a> from {previousConfidenceLevel} to {currentConfidenceLevel}.",

	[ `confidence${ ConfidenceLevel.HIGH }` ]: "High",
	[ `confidence${ ConfidenceLevel.MEDIUM }` ]: "Medium",
	[ `confidence${ ConfidenceLevel.LOW }` ]: "Low",
};
